/*
Akhila 12/19/2022 3075154998 Added Basic Info Form
Sohel  12/19/2022 3075154998 Added Validation.
Sohel  12/21/2022 3075154998 Added record Type Validation and dropdown values.
Sohel  12/21/2022 3075154998 Integrated Save API and Prepopulate Data.
Lalitha 12/26/2022 3075154998 Integrated get API on DMR code.
Sohel  12/29/2022 3075154998 Added Import Manager Record Screen
kavyareddy 12/30/2022 3075154998 Added master record field
Sohel 01/02/2023 2701323910 Basic Info Added fields and changed dropdown value
Sohel 01/03/2023 2701323910 Payload Changes
Sohel 01/03/2023 2701323910 hide Filter criteria step
Sohel 01/03/2023 2701323910 fixed line Terminate populate issue Issue
Sohel 01/04/2023 2698964415 Disabled Fields
Sohel 01/04/2023 2698964415 hide Filter Criteria step
Sohel 01/05/2023 2698964415 Added Footer Lines and Header Lines Fields
Sai maheshwar 01/06/2023 2701334326 added function lookup
Sohel 01/06/2023 2698964415 Changed Dropdown Value and disabled record Type
Sohel 01/07/2023 2698964415 Changed Dropdown Value and disabled record Type
Sohel 01/09/2023 2698964415 pass selected category in table Payload
Sohel 01/09/2022 2698964415 removed duplicate category field
Sohel 01/09/2023 2698964415 fixed field Length populate issue.
dilip 01/10/2023 2698964415 Added unsaved popup.
Sohel 01/11/2023 2698964415 change payload.
Sohel 01/11/2023 2698964415 changed field label
dilip 01/12/2023 2698964415 Added Parent Record and Sub Record Type Fields.
Sohel 01/12/2023 2698964415 fixed master record issue.
dilip 01/12/2023 2698964415 Fixed page break issue.
Lalitha 01/13/2023 2698964415 Fixed printFieldHeaders issue.
Sohel 01/12/2023 2698964415 initial value changes.
dilip 01/12/2023 2698964415 fixed Parent Record type validation issue.
Sohel 01/17/2023 2698964415 payload changes
Sohel 01/17/2023 2698964415 changed Save button condition
Sohel 01/18/2023 2698964415 fixed Field Prep populate issue
Sohel 01/20/2023 3075154998 changed Dropdown Values
Sohel 01/19/2023 2698964415 Added Last Step in Stepper
Sohel 01/23/2023 2698964415 fixed header lines populate issue
Sohel 01/22/2023 2698964415 duplicate check field added conditionally
Dilip 01/23/2023 2698964415 Added validation for header and footer line fields
Sohel 01/25/2023 2698964415 completed Status changes
Ashraf 01/27/2023 2698964415 added new fields
Sohel 01/30/2023 2698964415 field Separator and Record Separator Field Changes
Sohel 01/31/2023 2698964415 payload changes
Sohel 01/02/2023 2698964415 Added error props
Sohel 01/02/2023 2698964415 fixed code uppercase issue
Sohel 01/02/2023 2698964415 fixed validation issue
Suresh Peddavoora 02/01/2023 2698964415 Fixed Validation Message Alignments
Suresh Peddavoora 02/02/2023 2698964415 Alignment Fixes for Text Fields
Ashraf 02/03/2023 2698964415 Fixed prepopulation issue for line seperator.
Dilip 02/09/2023 2698964415 added creted for field and payload changes
Sohel 02/08/2023 2701335619 Implement Usage Functionality
Prakash 02/14/2023 2701335619 Implemented New UI Changes.
suresh peddavoora 02/22/2023 2701335619 New UI changes fixed
Rohini 02/28/2023 2701335619 added classname for screen enhancements.
suresh peddavoora 02/28/2023 2701335619 New UI changes fixed
Rohini 03/01/2023 2701335619 worked on the code enhancements.
Sohel 02/03/2023 2701335619 Added Dynamic Field
Sohel 02/03/2023 2701335619 Added Dynamic Field style changes
Sohel 02/03/2023 2701335619 Added Dynamic Field label change
Sohel 02/03/2023 2701335619 header line changes
Sohel 03/03/2023 2701335619 Added field separator and record separator validation style changes
Sohel 03/03/2023 2701335619 Added field separator and record separator validation
Sohel 03/03/2023 2701335619 Added field separator and record separator validation style changes
Sohel 03/03/2023 2701335619 fixed validation issue
Sohel 03/03/2023 2701335619 change regex
Sohel 03/03/2023 2701335619 payload changes
sohel 03/06/2023 2701335619 Added validation message for existing value
Sohel 03/08/2023 2701335619 hide Filter Criteria based on Duplicate Check
Sohel 03/09/2023 2701335619 disabled duplicate check
Prakash 03/17/2023 2701335619 fixed alignments in responsive.
Prakash 03/21/2023 2701335619 Fixed alignments issue.
suresh peddavoora 03/30/2023 2701335619 fixed textfields alignments
Akhila 04/13/2023 2701335619 removed new payment import
Prakash 13/04/2023 2701335619 remove margin-top
Sohel 04/26/2023 2692790263 Fixed Created FOr Validation Issue
Sohel 04/26/2023 2692790263 Fixed Record Separator prepopulate issue
Sohel 04/27/2023 2692790263 change sub record Type Value
Akhila 05/03/2023 2692790263 modifed field seprator and record seprator
Akhila 05/08/2023 2692790263 removed validation from field seprator and record seprator
Akhila 05/08/2023 2692790263 prepopulation issue in field seprator and record seprator fixed
Ravi 05/10/2023 2692790263 renamed parent record popup heading
Sohel 05/30/2023 2692790263 Added Star in Field and Record Separator
Sohel 05/30/2023 2692790263 Added FooterLines and Header Lines Validation Issue
Akhila 06/08/2023 2692790263 title label placeholder name change
Akhila 06/12/2023 2692790263 added role access
Ravi 06/15/2023 2692790263 Added value code in dropdown in seperator
Ravi 06/23/2023 2692790263 fixed submit issue
Sohel 11/20/2023 2692790263 Fixed Category Pre populate Issue
Sohel 11/12/2023 2692790263 code field and description field validation changes and case insenstive
Sohel 12/12/2023 2692790263 label name change code to name and validation changes
*/
import {
  Button,
  FormHelperText,
  TextField,
  MenuItem,
  Tooltip,
  InputAdornment,
} from '@material-ui/core';
import {Formik} from 'formik';
import * as Yup from 'yup';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {
  DM_FIELD_SEPERATOR,
} from '../../../../../constants/Lookup';
import {getDropDownData} from '../../../../../redux/reducers/BRE/AddRecordFormat';
import {
  fetchBasicInfoData,
  postBasicInfo,
  resetBasicInfo,
  fetchAllRecordCode,
  setHeaderLinesRedux,
} from '../../../../../redux/reducers/DataManagerRecord';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {setRecordGroupRedux} from '../../../../../redux/reducers/DataManagerRecordGroup';
import {
  setCategoryRedux,
  setFixedLengthRedux,
} from '../../../../../redux/reducers/DataManagerRecord';
import {Clear, Search} from '@material-ui/icons';
import DialogBox from '../../../../../components/DialogBox';
import SearchRecords from '../../../DataManager/DataManagerRecord/SearchDataManagerRecord';
import {currsorCodeIssue} from '../../../../../components/UpperCaseCode';
import {getAllReportCreatedForData} from '../../../../../redux/reducers/ReportMaster';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import ViewportList from 'react-viewport-list';
import {createForOptions} from '../../../../../util/CreatedByForOptions';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

const masterRecordOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];

const fixedLengthOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];
const importType = [
  {value: 'New Account Import'},
  // { value: "New Payment Import" },
  {value: 'Data Update'},
  {value: 'Customer Query'},
  {value: 'Exception'},
  {value: 'Header'},
  {value: 'Footer'},
];
const exportType = [{value: 'Data Export'}, {value: 'Header'}, {value: 'Footer'}];
const DMRBasicInfo = ({
  activeStep,
  handleNext,
  exportManagerRecord,
  hideRule,
  showAlertRef,
  handleDirty,
  setExceptionType,
  exceptionType,
  dmTempRecordAccess,
  editExisting,
  importRecordGroupAccess,
  exportRecordGroupAccess,
}) => {
  const {reusableInputStyles, sideNavSection} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {dropDownData} = useSelector(({addRecordFormat}) => addRecordFormat);
  const [mappedRecordForExceptionData, setMappedRecordForExceptionData] = useState(null);
  const {reportCreatedForData} = useSelector(({reportMaster}) => reportMaster);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    isBasicInfoLoading,
    basicInfoSuccessMsg,
    basicInfoErrorMsg,
    basicInfoStatus,
    dataManagerRecordId,
    basicInfoData,
    allRecordCode,
    isDraftRecord,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const saveRef = useRef();
  const [codePopover, setCodePopover] = useState(false);
  const [recordCodesData, setRecordCodesData] = useState();
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const changesToWrite = [{value: 'All Changes'}, {value: 'Last Change'}];
  const type = exportManagerRecord ? 'Export' : 'Import';
  const ref = useRef(null);
  const codeRef = useRef();
  const codeRef1 = useRef();

  const checkRecordCodeExist = (value) => {
    if (allRecordCode && allRecordCode?.length > 0 && value) {
      const ar = [];
      allRecordCode.filter((i) => {
        if (
          i?.recordCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkRecordCodeAlreadyExist = (value) => {
    if (allRecordCode && allRecordCode?.length > 0 && value) {
      const ar = [];
      allRecordCode.filter((i) => {
        if (
          i?.recordCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  const strategyType = [
    {value: 'Changed Field From Audit & Other fields Blank'},
    {value: 'Changed fields from Audit & Others from Account'},
    {value: 'Changed fields from Account & Other Blank'},
    {value: 'Fill from Account'},
  ];
  const validationSchema = Yup.object().shape({
    code: basicInfoData?.recordCode
      ? null
      : Yup.string()
        .required(`${type} Template Record Name is required`)
        .test(
          'code',
            `${type} Template Record Name already exist`,
            (value) => !checkRecordCodeExist(value),
        )
        .test(
          'code',
            `${type} Template Record Name has already been used in the past`,
            (value) => !checkRecordCodeAlreadyExist(value),
        ),
    recordDescription: Yup.string()
      .test('description', `${type} Template Description is required`, (value) => {
        return value?.replaceAll(' ', '');
      })
      .required(`${type} Template Description is required`),
    fixedLength: Yup.mixed().test('fixedLength', 'Fixed Length is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    dynamic: Yup.mixed().test('dynamic', 'Dynamic Column Mapping is required', (value, ctx) => {
      if (!value?.value && ctx.parent.headerLines) {
        return false;
      } else {
        return true;
      }
    }),
    recordType: Yup.mixed().test('recordType', `Record Type is required`, (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    fieldSeparator: Yup.string()
      // .matches(
      //   /^[A-Z@~`!@#$%^&*()_=+\\';:"\/?>.<,-\|]*$/i,
      //   "Only alphabets and special character are allowed"
      // )
      .test('fieldSeparator', 'Field Separator is required', (value, ctx) => {
        if (!value && ctx.parent.fixedLength?.key === 'N') {
          return false;
        } else {
          return true;
        }
      }),
    // .test("field Separator", "Please add valid Field Separator", (val, ctx) => {
    //   if ((val && val?.length === 1 && val !== "\\") || ctx.parent.fixedLength?.key !== "N") {
    //     return true;
    //   } else if (
    //     val &&
    //     val[0] === "\\" &&
    //     val[1] !== "\\" &&
    //     val.length === 2 &&
    //     ctx.parent.fixedLength?.key === "N"
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }),
    // .test("fieldSeparator", "Field Separator is required", (value, ctx) => {
    //   if (!value?.value && ctx.parent.fixedLength?.key === "N") {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }),
    lineTerminator: Yup.string().test(
      'lineTerminator',
      'Record Separator is required',
      (value, ctx) => {
        if (!value) {
          return false;
        } else {
          return true;
        }
      },
    ),
    // .test("lineTerminator", "Please add valid Record Separator", (val, ctx) => {
    //   if ((val && val?.length === 1 && val !== "\\") || ctx.parent.fixedLength?.key !== "N") {
    //     return true;
    //   } else if (
    //     val &&
    //     val[0] === "\\" &&
    //     val[1] !== "\\" &&
    //     val.length === 2 &&
    //     ctx.parent.fixedLength?.key === "N"
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }),
    // .matches(
    //   /^[A-Z@~`!@#$%^&*()_=+\\';:"\/?>.<,-\|]*$/i,
    //   "Only alphabets and special character are allowed"
    // ),
    // .test("lineTerminator", "Record Separator is required", (value, ctx) => {
    //   if (!value?.value) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // .test("lineTerminator", "Record Separator is required", (value, ctx) => {
    //   console.log(value, "value101");
    //   if (!value) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }),
    // .test("lineTerminator", "Record Separator is required", (value) => {
    //   return value?.replaceAll("\\", "");
    // }),

    duplicateCheck: Yup.mixed().test(
      'duplicateCheck',
      `Duplicate Check is required`,
      (value, ctx) => {
        if (
          !value?.value &&
          ctx.parent?.recordType?.value === 'New Account Import' &&
          ctx.parent?.masterRecord?.key === 'Y'
        ) {
          return false;
        } else {
          return true;
        }
      },
    ),
    masterRecord: Yup.mixed().test('masterRecord', `Master Record is required`, (value, ctx) => {
      if (
        !value?.value &&
        ['New Account Import', 'Data Update', 'New Payment Import'].includes(
          ctx.parent.recordType?.value,
        )
      ) {
        return false;
      } else {
        return true;
      }
    }),
    // changesToWrite: Yup.mixed().test(
    //   "changesToWrite",
    //   `Changes To Write is required`,
    //   (value, ctx) => {
    //     if (!value?.value && ctx.parent.recordType?.value === "Data Export") {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   }
    // ),
    // strategy: Yup.mixed().test("strategy", `Field Populate Strategy is required`, (value, ctx) => {
    //   if (!value?.value && ctx.parent.recordType?.value === "Data Export") {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }),
    includeAudit:
      exportManagerRecord && Yup.mixed().required('Include Audit is required').nullable(),
    headerLines: Yup.number()
      .min(0, 'Negative numbers are not allowed')
      .nullable(true)
      .transform((value) =>
        value === '' || value === null || value === undefined || value !== Number(value)
          ? null
          : value,
      ),
    footerLines: Yup.number()
      .min(0, 'Negative numbers are not allowed')
      .nullable(true)
      .transform((value) =>
        value === '' || value === null || value === undefined || value !== Number(value)
          ? null
          : value,
      ),
    // category: Yup.object().required("Category is required").nullable(),
    parentRecord: Yup.mixed().test('parentRecord', 'Parent Record is required', (value, ctx) => {
      if (!value && ctx.parent.recordType?.value === 'Exception') {
        return false;
      } else {
        return true;
      }
    }),
    subRecordType: Yup.mixed().test(
      'subRecordType',
      'Sub Record Type is required',
      (value, ctx) => {
        if (!value?.value && ctx.parent.recordType?.value === 'Exception') {
          return false;
        } else {
          return true;
        }
      },
    ),
  });
  const [nameData, setNameData] = useState();
  const [namePopover, setNamePopover] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [nameData1, setNameData1] = useState();
  const [namePopover1, setNamePopover1] = useState(false);
  const [selectedOption1, setSelectedOption1] = useState('');
  const keyPress = (e, setFieldValue) => {
    if (e.key === 'Enter') {
      setFieldValue(
        'fieldSeparator',
        selectedOption ? selectedOption : getWindowNameData()[0]?.value,
      );
      setSelectedOption(selectedOption ? selectedOption : getWindowNameData()[0]?.value);
    }
  };
  const keyPress1 = (e, setFieldValue) => {
    if (e.key === 'Enter') {
      setFieldValue(
        'lineTerminator',
        selectedOption1 ? selectedOption1 : getRecordSepratorData()[0]?.value,
      );
      setSelectedOption1(selectedOption1 ? selectedOption1 : getRecordSepratorData()[0]?.value);
    }
  };
  const data1 = dropDownData ? dropDownData[DM_FIELD_SEPERATOR] : [];
  const getWindowNameData = () => {
    if (data1 && data1?.length > 0 && nameData) {
      return data1?.filter((i) => String(i?.value)?.includes(nameData));
    } else {
      return data1?.length > 0 ? data1 : [];
    }
  };

  const getRecordSepratorData = () => {
    if (data1 && data1?.length > 0 && nameData1) {
      return data1?.filter((i) => String(i?.value)?.includes(nameData1));
    } else {
      return data1?.length > 0 ? data1 : [];
    }
  };
  const categoryData = [
    {
      categoryCode: 'CO',
      categoryName: 'Core',
    },
  ];
  const promptOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option || item.key === option || item.categoryCode === option) {
          label = item;
        }
      });
    return label;
  };

  const getObjectData = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item.value === option ||
          item.key === option ||
          item.userName === option ||
           item.userLoginName === option ||
          item.categoryCode === option
        ) {
          label = item;
        }
      });
    return label;
  };
  const recordType = getObject(basicInfoData?.recordType, [...exportType, ...importType]);
  const masterRecord =
    type === 'Import' && basicInfoData?.masterRecord ?
      getObject(basicInfoData?.masterRecord, masterRecordOptions) :
      {key: 'Y', value: 'Yes'};
  const category = basicInfoData?.category ?
    getObject(basicInfoData?.category, categoryData) :
    {categoryCode: 'CO', categoryName: 'Core'};
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  const initialState = {
    code: basicInfoData?.recordCode ? basicInfoData?.recordCode : '',
    recordDescription: basicInfoData?.recordDescription ? basicInfoData?.recordDescription : '',
    recordType: basicInfoData?.recordType ? recordType : '',
    fixedLength: basicInfoData?.fixedLength ?
      getObject(basicInfoData?.fixedLength, fixedLengthOptions) :
      {key: 'N', value: 'No'},
    // fieldSeparator:
    //   basicInfoData?.fixedLength === "N" && basicInfoData?.fieldSeparator
    //     ? getValueObject(basicInfoData?.fieldSeparator, FIELD_SEPERATOR, dropDownData)
    //     : getValueObject(",", FIELD_SEPERATOR, dropDownData),
    fieldSeparator:
      basicInfoData?.fixedLength === 'N' && basicInfoData?.fieldSeparator ?
        basicInfoData?.fieldSeparator :
        '',
    // ? getValueObject(basicInfoData?.fieldSeparator, DM_FIELD_SEPERATOR, dropDownData)?.value
    // : "",
    masterRecord: masterRecord,
    subRecordType:
      basicInfoData?.masterRecord && basicInfoData?.subRecordType ?
        {value: basicInfoData?.subRecordType} :
        '',
    lineTerminator: basicInfoData?.lineTerminator ? basicInfoData?.lineTerminator : '',
    // ? getValueObject(basicInfoData?.lineTerminator, DM_FIELD_SEPERATOR, dropDownData)?.value
    // : "",
    duplicateCheck:
      basicInfoData?.recordType === 'New Account Import' && basicInfoData?.duplicateCheck ?
        getObject(basicInfoData?.duplicateCheck, fixedLengthOptions) :
        [
          {key: 'Y', value: 'Yes'},
          {key: 'N', value: 'No'}
        ],
    changesToWrite:
      basicInfoData?.recordType === 'Data Export' && basicInfoData?.changeToWrite ?
        getObject(basicInfoData?.changeToWrite, changesToWrite) :
        '',
    parentRecord: exceptionType && basicInfoData?.masterRecord ? basicInfoData?.masterRecord : '',
    strategy:
      basicInfoData?.recordType === 'Data Export' && basicInfoData?.fieldStrategy ?
        getObject(basicInfoData?.fieldStrategy, strategyType) :
        '',
    footerLines: exportManagerRecord ?
      '' :
      basicInfoData?.footerLineNumbers ?
        basicInfoData?.footerLineNumbers :
        '',
    headerLines: exportManagerRecord ?
      '' :
      basicInfoData?.headerLineNumbers ?
        basicInfoData?.headerLineNumbers :
        '',
    printFieldHeaders:
      basicInfoData?.recordType === 'Data Export' && basicInfoData?.printFieldHeaders ?
        getObject(basicInfoData?.printFieldHeaders, fixedLengthOptions) :
        {key: 'N', value: 'No'},
    category: category,
    includeAudit: basicInfoData?.includeAudit ?
      getObject(basicInfoData?.includeAudit, promptOptions) :
      {key: 'N', value: 'No'},
    createdFor: basicInfoData?.createdFor ?
      getObjectData(basicInfoData?.createdFor, reportCreatedForData) :
      {userLoginName: user?.userName},
    dynamic: basicInfoData?.dynamic ? getObject(basicInfoData?.dynamic, fixedLengthOptions) : '',
  };
  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const payload = {
        dataManagerRecordId: basicInfoData?.dataManagerRecordId ?
          basicInfoData?.dataManagerRecordId :
          '0',
        category: 'CO',
        dynamic:
          Number(values?.headerLines) !== 0 && values?.dynamic?.key ? values?.dynamic?.key : '',
        createdFor: values?.createdFor?.userLoginName ? values?.createdFor?.userLoginName : '',
        recordCode: values?.code ? values?.code : '',
        recordDescription: values?.recordDescription ? values?.recordDescription : '',
        recordType: values?.recordType?.value ? values?.recordType?.value : '',
        fixedLength: values?.fixedLength?.key ? values?.fixedLength?.key : '',
        fieldSeparator:
          values?.fixedLength?.key === 'N' && values?.fieldSeparator ? values?.fieldSeparator : '',
        masterRecord: ['New Account Import', 'Data Update', 'New Payment Import']?.includes(
          values?.recordType?.value,
        ) ?
          values?.masterRecord?.key || '' :
          exceptionType ?
            values?.parentRecord :
            '',
        subRecordType: values?.subRecordType?.value,
        duplicateCheck:
          values?.recordType?.value === 'New Account Import' &&
          values?.masterRecord?.key === 'Y' &&
          values?.duplicateCheck?.key ?
            values?.duplicateCheck?.key :
            '',
        lineTerminator: values?.lineTerminator ? values?.lineTerminator : '',
        isDarft: basicInfoData?.isDraft ? basicInfoData?.isDraft : 'Y',
        type: type,
        fieldStrategy: values?.strategy?.value ? values?.strategy?.value : '',
        changeToWrite: values?.changesToWrite?.value ? values?.changesToWrite?.value : '',
        printFieldHeaders:
          values?.recordType.value === 'Data Export' && values?.printFieldHeaders?.key ?
            values?.printFieldHeaders?.key :
            '',
        includeAudit: values?.includeAudit?.key ? values?.includeAudit?.key : '',
        footerLineNumbers: [
          'New Account Import',
          'Data Update',
          'New Payment Import',
          'Customer Query',
        ].includes(values?.recordType?.value) ?
          Number(values?.footerLines) :
          '',
        headerLineNumbers: [
          'New Account Import',
          'Data Update',
          'New Payment Import',
          'Customer Query',
        ].includes(values?.recordType?.value) ?
          Number(values?.headerLines) :
          '',
        lastStep:
          isDraftRecord === 'N' ?
            basicInfoData?.lastStep :
            saveRef.current ?
              basicInfoData?.lastStep :
              1,
      };
      dispatch(postBasicInfo(payload));
    }
  };
  useEffect(() => {
    document.addEventListener('click', (e) => {
      if (!e?.target?.id) {
        setNamePopover1(false);
        setNamePopover(false);
      }
    });
    return () => {
      document.removeEventListener('click', () => {});
    };
  }, []);

  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);
  useEffect(() => {
    if ('recordType' in basicInfoData) {
      dispatch(
        setRecordGroupRedux({
          property: 'recordType',
          value: recordType,
        }),
      );
    }
  }, [basicInfoData?.recordType]);
  useEffect(() => {
    if ('headerLineNumbers' in basicInfoData) {
      dispatch(
        setHeaderLinesRedux({
          property: 'headerLines',
          value: basicInfoData?.headerLineNumbers,
        }),
      );
    }
  }, [basicInfoData?.headerLineNumbers]);
  useEffect(() => {
    if ('fixedLength' in basicInfoData) {
      dispatch(
        setFixedLengthRedux({
          property: 'fixedLength',
          value: basicInfoData?.fixedLength,
        }),
      );
    }
  }, [basicInfoData?.fixedLength]);
  useEffect(() => {
    if ('category' in basicInfoData) {
      dispatch(setCategoryRedux({property: 'category', value: category}));
    }
  }, [basicInfoData?.category]);

  useEffect(() => {
    if ('masterRecord' in basicInfoData) {
      dispatch(
        setRecordGroupRedux({
          property: 'masterRecord',
          value: masterRecord,
        }),
      );
      if (basicInfoData?.recordType === 'Exception') {
        setExceptionType(true);
      }
    }
    const hide = ['New Account Import']?.includes(basicInfoData?.recordType) ?
      masterRecord?.key === 'Y' && basicInfoData?.duplicateCheck === 'Y' :
      ['Data Update']?.includes(basicInfoData?.recordType) ?
        masterRecord?.key === 'Y' :
        false;
    hideRule(hide);
  }, [basicInfoData?.recordType]);
  useEffect(() => {
    if ('masterRecord' in basicInfoData && exceptionType) {
      setMappedRecordForExceptionData({recordCode: basicInfoData?.masterRecord});
    }
  }, [basicInfoData?.recordType]);

  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        if (basicInfoSuccessMsg && !saveRef.current && basicInfoStatus === 200) {
          handleNext();
        }
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg, basicInfoStatus]);

  useEffect(() => {
    if (dataManagerRecordId) {
      dispatch(fetchBasicInfoData(dataManagerRecordId));
    }
  }, [dataManagerRecordId]);
  useEffect(() => {
    dispatch(fetchAllRecordCode(type));
  }, []);

  window.onclick = function() {
    setCodePopover(false);
  };

  const getRecordCodesData = () => {
    if (allRecordCode && allRecordCode?.length > 0) {
      return allRecordCode?.filter((i) =>
        String(i.recordCode?.toLowerCase())?.startsWith(recordCodesData?.toLowerCase()),
      );
    } else {
      return [];
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialState}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          let hide = false;
          if (
            values?.masterRecord?.key === 'Y' &&
            ['New Account Import']?.includes(values?.recordType?.value) &&
            values?.duplicateCheck?.key === 'Y'
          ) {
            hide = true;
          } else if (
            values?.masterRecord?.key === 'Y' &&
            ['Data Update']?.includes(values?.recordType?.value)
          ) {
            hide = true;
          } else {
            hide = false;
          }
          hideRule(hide);
          return (
            <>
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="form-row global-field-textfields new-standard-textfields mt-2">
                  <div
                    className={`${
                      sideNavSection
                        ? 'col-sm-6 col-md-4 col-xl-3 custom-field-name'
                        : errors?.code?.length > 30
                          ? 'col-sm-6 col-md-4 col-xl-3 form-group-lg'
                          : 'col-sm-6 col-md-4 col-xl-3 form-group'
                    }`}
                  >
                    <TextField
                      className={` ${classes.labelName} `}
                      placeholder={`Enter ${type} Template Record Name`}
                      margin="dense"
                      name="code"
                      variant="outlined"
                      value={values?.code}
                      disabled={Boolean(basicInfoData?.recordCode)}
                      label={`${type} Template Record Name`}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      inputProps={{ maxLength: 25 }}
                      required
                      onBlur={handleBlur}
                      inputRef={codeRef1}
                      onChange={(e) => {
                        const value = currsorCodeIssue(codeRef1);
                        setFieldValue('code', value);
                        if (e.target.value) {
                          setCodePopover(true);
                          setRecordCodesData(e.target.value);
                        } else if (e.target.value === '') {
                          setCodePopover(false);
                        }
                      }}
                      touched={touched.code}
                      error={Boolean(errors.code && touched.code)}
                      fullWidth
                    />
                    <FormHelperText style={{ color: 'red' }} variant="outlined">
                      {touched.code && errors.code}
                    </FormHelperText>
                    <div className="windowcode-popover Add-trigger-group-popover">
                      {codePopover &&
                        getRecordCodesData()?.map((data, i) => (
                          <MenuItem fullWidth key={i}>
                            {data?.recordCode?.replace(/ /g, '\u00a0')}
                          </MenuItem>
                        ))}
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    <TextField
                      className={` ${classes.labelName} `}
                      placeholder={`Enter ${type} Template Description`}
                      margin="dense"
                      name="recordDescription"
                      value={values.recordDescription}
                      inputProps={{ maxLength: 100 }}
                      variant="outlined"
                      label={`${type} Template Description`}
                      error={Boolean(touched.recordDescription && errors.recordDescription)}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      required
                      fullWidth
                    />
                    <FormHelperText style={{ color: 'red' }} variant="outlined">
                      {touched.recordDescription && errors.recordDescription}
                    </FormHelperText>
                  </div>

                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="createdFor"
                      id="createdFor"
                      size="small"
                      value={values.createdFor}
                      options={reportCreatedForData}
                      getOptionLabel={(option) => {
                        return option && option?.userLoginName ? option?.userLoginName : '';
                      }}
                      renderOption={(option) => {
                        return createForOptions(option);
                      }}
                      onChange={(e, value) => {
                        handleChange(e);
                        setFieldValue('createdFor', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            label="Created For"
                            className={` ${classes.labelName} `}
                            placeholder="Select Created For"
                          />
                          <FormHelperText variant="outlined">
                            {touched.createdFor && errors.createdFor}
                          </FormHelperText>
                        </div>
                      )}
                    />
                  </div>

                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="recordType"
                      id="recordType"
                      size="small"
                      value={values.recordType}
                      options={exportManagerRecord ? exportType : importType}
                      // getOptionDisabled={(option) => option.valueCode === ""}
                      disabled={Boolean(basicInfoData?.recordType)}
                      getOptionLabel={(option) => {
                        return option?.value ? option?.value : '';
                      }}
                      autoHighlight
                      onChange={(e, value) => {
                        setExceptionType(value?.value === 'Exception');
                        setFieldValue('strategy', '');
                        setFieldValue('changesToWrite', '');
                        setFieldValue('footerLines', '');
                        setFieldValue('headerLines', '');
                        dispatch(setRecordGroupRedux({ property: 'recordType', value: value }));
                        setFieldValue('recordType', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName} `}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            name="recordType"
                            error={Boolean(touched.recordType && errors.recordType)}
                            label={`Record Type`}
                            required
                            onBlur={handleBlur}
                            placeholder={`Select Record Type`}
                          />
                          <FormHelperText style={{ color: 'red' }} variant="outlined">
                            {touched.recordType && errors.recordType}
                          </FormHelperText>
                        </div>
                      )}
                    />
                  </div>
                  {values?.recordType?.value === 'Exception' ? (
                    <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="subRecordType"
                        id="subRecordType"
                        size="small"
                        value={values.subRecordType}
                        options={[
                          { value: 'Exception Header' },
                          { value: 'Exception Footer' },
                          { value: 'Exception Record' },
                        ]}
                        disabled={Boolean(basicInfoData?.subRecordType)}
                        getOptionLabel={(option) => {
                          return option?.value ? option?.value : '';
                        }}
                        autoHighlight
                        onChange={(e, value) => {
                          setFieldValue('subRecordType', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName} `}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              error={Boolean(touched.subRecordType && errors.subRecordType)}
                              label={`Sub Record Type`}
                              required
                              placeholder={`Select Sub Record Type`}
                            />
                            <FormHelperText style={{ color: 'red' }} variant="outlined">
                              {touched.subRecordType && errors.subRecordType}
                            </FormHelperText>
                          </div>
                        )}
                      />
                    </div>
                  ) : null}
                  {values?.recordType?.value === 'Exception' ? (
                    <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                      <TextField
                        margin="dense"
                        className={` ${classes.labelName} `}
                        variant="outlined"
                        placeholder={`Select Parent Record`}
                        label="Parent Record"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="parentRecord"
                        value={
                          // mappedRecordForExceptionData?.recordCode
                          //   ? mappedRecordForExceptionData?.recordCode
                          //   :
                          values?.parentRecord || ''
                        }
                        fullWidth
                        handleBlur={handleBlur}
                        required
                        touched={touched?.record}
                        disabled
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {!(exceptionType && basicInfoData?.masterRecord) && (
                                <>
                                  <Tooltip title={'Search'}>
                                    <Search
                                      className={` ${classes.iconSearch} `}
                                      size="sm"
                                      disabled={Boolean(
                                        exceptionType && basicInfoData?.masterRecord,
                                      )}
                                      onClick={() => {
                                        setOpen(true);
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip title={'Clear'}>
                                    <Clear
                                      className={` ${classes.iconSearch} `}
                                      onClick={() => {
                                        setFieldValue('parentRecord', '');
                                        setMappedRecordForExceptionData(null);
                                      }}
                                    />
                                  </Tooltip>
                                </>
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                      <FormHelperText style={{ color: 'red' }}>
                        {touched?.parentRecord && errors?.parentRecord}
                      </FormHelperText>
                    </div>
                  ) : null}
                  <div className={`col-sm-6 col-md-4 col-xl-3 form-group`}>
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      id="fixedLength"
                      options={fixedLengthOptions}
                      value={values?.fixedLength}
                      size="small"
                      autoHighlight
                      disabled={Boolean(basicInfoData?.fixedLength)}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      onChange={(e, data) => {
                        setFieldValue('fieldSeparator', '');
                        setFieldValue('lineTerminator', '');
                        setFieldValue('fixedLength', data);
                        dispatch(
                          setFixedLengthRedux({
                            property: 'fixedLength',
                            value: data?.key,
                          }),
                        );
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          margin="dense"
                          {...params}
                          className={` ${classes.labelName} `}
                          variant="outlined"
                          fullWidth
                          label="Fixed Length"
                          required
                          error={Boolean(touched.fixedLength && errors.fixedLength)}
                          name="fixedLength"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          placeholder="Select Fixed Length"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                    />
                    <FormHelperText style={{ color: 'red' }} variant="outlined">
                      {touched.fixedLength && errors.fixedLength}
                    </FormHelperText>
                  </div>
                  {values?.fixedLength?.key === 'N' && (
                    <>
                      <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                        {/* <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="fieldSeparator"
                          id="fieldSeparator"
                          size="small"
                          value={values.fieldSeparator}
                          options={getOptions(DM_FIELD_SEPERATOR, dropDownData)}
                          getOptionLabel={(option) => {
                            return option?.value ? option?.value : "";
                          }}
                          onChange={(e, value) => {
                            setFieldValue("fieldSeparator", value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName} `}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Field Separator"
                                required
                                error={Boolean(touched.fieldSeparator && errors.fieldSeparator)}
                                placeholder="Select Field Separator"
                              />
                              <FormHelperText variant="outlined">
                                {touched.fieldSeparator && errors.fieldSeparator}
                              </FormHelperText>
                            </div>
                          )}
                        /> */}
                        <TextField
                          id="fieldSeparator"
                          onClick={() => setNamePopover(!namePopover)}
                          margin="dense"
                          className={`${classes.labelName}`}
                          variant="outlined"
                          placeholder="Select Field Separator"
                          label="Field Separator"
                          name="fieldSeparator"
                          onKeyDown={(e) => keyPress(e, setFieldValue)}
                          value={values?.fieldSeparator}
                          InputProps={{
                            max: 4,
                            // endAdornment:
                            //   <InputAdornment position="end" className="repo-name"  >
                            //     {<div onclick={() => setNamePopover(true)}> {namePopover ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</div>}
                            //   </InputAdornment>,
                          }}
                          onChange={(e) => {
                            setNamePopover(true);
                            setFieldValue('fieldSeparator', e.target?.value);
                            if (e.target.value) {
                              setNameData(e?.target?.value);
                            } else if (e.target.value === '') {
                              setNameData('');
                              setSelectedOption('');
                            }
                          }}
                          onBlur={handleBlur}
                          inputRef={codeRef}
                          fullWidth
                          required
                          touched={touched.fieldSeparator}
                          error={Boolean(touched.fieldSeparator && errors.fieldSeparator)}
                        />
                        <FormHelperText>
                          {touched.fieldSeparator && errors.fieldSeparator && errors.fieldSeparator}
                        </FormHelperText>
                        {namePopover &&
                          getWindowNameData(DM_FIELD_SEPERATOR, dropDownData)?.length > 0 && (
                          <div
                            ref={ref}
                            className={`pt-2 pb-2 windowcode-popover Add-trigger-group-popover data-repo-popover-width ${
                                namePopover ? 'popover-open' : ''
                              }`}
                          >
                            {namePopover && (
                              <ViewportList
                                viewportRef={ref}
                                items={getWindowNameData(DM_FIELD_SEPERATOR, dropDownData)}
                                itemMinSize={10}
                              >
                                {(item) => (
                                  <div className="data-repo-popover" key={item?.id}>
                                    <p
                                      className={`${
                                          selectedOption === item?.repositoryName
                                            ? 'selected-dropdown-option'
                                            : ''
                                        }`}
                                      onClick={() => {
                                        setFieldValue('fieldSeparator', item?.value);
                                        setSelectedOption(item?.value);
                                        setNamePopover(false);
                                      }}
                                    >
                                      {item?.value}&nbsp;&nbsp;({item?.valueCode})
                                    </p>
                                  </div>
                                )}
                              </ViewportList>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    {/* <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="lineTerminator"
                      id="lineTerminator"
                      size="small"
                      value={values.lineTerminator}
                      options={getOptions(DM_FIELD_SEPERATOR, dropDownData)}
                      getOptionLabel={(option) => {
                        return option?.value ? option?.value : "";
                      }}
                      onChange={(e, value) => {
                        setFieldValue("lineTerminator", value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName} `}
                            {...params}
                            variant="outlined"
                            margin="dense"
                            label="Record Separator"
                            required
                            error={Boolean(touched.lineTerminator && errors.lineTerminator)}
                            placeholder="Select Record Separator"
                          />
                          <FormHelperText variant="outlined">
                            {touched.lineTerminator && errors.lineTerminator}
                          </FormHelperText>
                        </div>
                      )}
                    /> */}
                    <TextField
                      id="lineTerminator"
                      onClick={() => setNamePopover1(!namePopover1)}
                      margin="dense"
                      className={`${classes.labelName}`}
                      variant="outlined"
                      placeholder="Select Record Separator"
                      label="Record Separator"
                      name="lineTerminator"
                      onKeyDown={(e) => keyPress1(e, setFieldValue)}
                      value={values?.lineTerminator}
                      // InputProps={{
                      //   endAdornment:
                      //     <InputAdornment position="end" className="repo-name"  >
                      //       {<div onclick={() => setNamePopover(true)}> {namePopover ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</div>}
                      //     </InputAdornment>,
                      // }}
                      onChange={(e) => {
                        setNamePopover1(true);
                        setFieldValue('lineTerminator', e.target?.value);
                        if (e.target.value) {
                          setNameData1(e?.target?.value);
                        } else if (e.target.value === '') {
                          setNameData1('');
                          setSelectedOption1('');
                        }
                      }}
                      onBlur={handleBlur}
                      inputRef={codeRef}
                      fullWidth
                      required
                      touched={touched.lineTerminator}
                      error={Boolean(touched.lineTerminator && errors.lineTerminator)}
                    />
                    <FormHelperText>
                      {touched.lineTerminator && errors.lineTerminator && errors.lineTerminator}
                    </FormHelperText>
                    {namePopover1 &&
                      getRecordSepratorData(DM_FIELD_SEPERATOR, dropDownData)?.length > 0 && (
                      <div
                        ref={ref}
                        className={`pt-2 pb-2 windowcode-popover Add-trigger-group-popover data-repo-popover-width ${
                            namePopover1 ? 'popover-open' : ''
                          }`}
                      >
                        {namePopover1 && (
                          <ViewportList
                            viewportRef={ref}
                            items={getRecordSepratorData(DM_FIELD_SEPERATOR, dropDownData)}
                            itemMinSize={10}
                          >
                            {(item) => (
                              <div className="data-repo-popover" key={item?.id}>
                                <p
                                  className={`${
                                      selectedOption === item?.repositoryName
                                        ? 'selected-dropdown-option'
                                        : ''
                                    }`}
                                  onClick={() => {
                                    setFieldValue('lineTerminator', item?.value);
                                    setSelectedOption1(item?.value);
                                    setNamePopover1(false);
                                  }}
                                >
                                  {item?.value}&nbsp;&nbsp;({item?.valueCode})
                                </p>
                              </div>
                            )}
                          </ViewportList>
                        )}
                      </div>
                    )}
                  </div>
                  {[
                    'New Account Import',
                    'Data Update',
                    'New Payment Import',
                    'Customer Query',
                  ].includes(values?.recordType?.value) && (
                    <>
                      <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                        <TextField
                          className={` ${classes.labelName} `}
                          placeholder={`Enter Header Lines`}
                          margin="dense"
                          name="headerLines"
                          type="number"
                          inputProps={{ min: 0 }}
                          value={values.headerLines}
                          variant="outlined"
                          label={`Header Lines`}
                          error={Boolean(touched.headerLines && errors.headerLines)}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue('headerLines', e.target.value);
                            dispatch(
                              setHeaderLinesRedux({
                                property: 'headerLines',
                                value: e.target.value,
                              }),
                            );
                          }}
                          fullWidth
                        />
                        <FormHelperText variant="outlined">
                          {touched.headerLines && errors.headerLines}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                        <TextField
                          className={` ${classes.labelName} `}
                          placeholder={`Enter Footer Lines`}
                          type="number"
                          margin="dense"
                          name="footerLines"
                          value={values.footerLines}
                          inputProps={{ min: 0 }}
                          disabled={Boolean(basicInfoData?.footerLines)}
                          variant="outlined"
                          label={`Footer Lines`}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          fullWidth
                        />
                        <FormHelperText variant="outlined">
                          {touched.footerLines && errors.footerLines}
                        </FormHelperText>
                      </div>
                    </>
                  )}
                  {['Data Export'].includes(values?.recordType?.value) && (
                    <div className={`col-sm-6 col-md-4 col-lg-4 col-xl-3 form-group`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        id="printFieldHeaders"
                        options={masterRecordOptions}
                        value={values?.printFieldHeaders}
                        size="small"
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option.value;
                        }}
                        onChange={(e, data) => {
                          setFieldValue('printFieldHeaders', data);
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            margin="dense"
                            {...params}
                            className={` ${classes.labelName} `}
                            variant="outlined"
                            fullWidth
                            label="Print Field Headers"
                            error={Boolean(touched.printFieldHeaders && errors.printFieldHeaders)}
                            name="printFieldHeaders"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            placeholder="Select Print Field Headers"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                      />
                      <FormHelperText style={{ color: 'red' }} variant="outlined">
                        {touched.printFieldHeaders && errors.printFieldHeaders}
                      </FormHelperText>
                    </div>
                  )}
                  {['New Account Import', 'Data Update', 'New Payment Import'].includes(
                    values?.recordType?.value,
                  ) && (
                    <>
                      <div className={`col-sm-6 col-md-4 col-xl-3 form-group`}>
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          id="masterRecord"
                          options={masterRecordOptions}
                          value={values?.masterRecord}
                          size="small"
                          autoHighlight
                          getOptionLabel={(option) => {
                            return option && option.value;
                          }}
                          onChange={(e, data) => {
                            setFieldValue('masterRecord', data);
                            // hideRule(
                            //   data.value === "Yes" &&
                            //     [
                            //       "New Account Import",
                            //       "Data Update",
                            //       "New Payment Import",
                            //     ]?.includes(values?.recordType?.value)
                            // );
                            dispatch(
                              setRecordGroupRedux({ property: 'masterRecord', value: data }),
                            );
                          }}
                          disabled={Boolean(basicInfoData?.masterRecord)}
                          renderInput={(params) => (
                            <GuiTextField
                              margin="dense"
                              {...params}
                              className={` ${classes.labelName} `}
                              variant="outlined"
                              fullWidth
                              label="Master Record"
                              required
                              error={Boolean(touched.masterRecord && errors.masterRecord)}
                              name="masterRecord"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              placeholder="Select  Master Record"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'off',
                              }}
                            />
                          )}
                        />
                        <FormHelperText style={{ color: 'red' }} variant="outlined">
                          {touched.masterRecord && errors.masterRecord}
                        </FormHelperText>
                      </div>
                      {values?.recordType?.value === 'New Account Import' &&
                        values?.masterRecord?.key === 'Y' && (
                        <div className={`col-sm-6 col-md-4 col-xl-3 form-group`}>
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            id="duplicateCheck"
                            options={masterRecordOptions}
                            value={values?.duplicateCheck}
                            size="small"
                            autoHighlight
                            getOptionLabel={(option) => {
                              return option && option.value;
                            }}
                            onChange={(e, data) => {
                              setFieldValue('duplicateCheck', data);
                            }}
                            renderInput={(params) => (
                              <GuiTextField
                                margin="dense"
                                {...params}
                                className={` ${classes.labelName} `}
                                variant="outlined"
                                fullWidth
                                label="Duplicate Check"
                                required
                                error={Boolean(touched.duplicateCheck && errors.duplicateCheck)}
                                name="duplicateCheck"
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                placeholder="Select  Duplicate Check"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            )}
                          />
                          <FormHelperText style={{ color: 'red' }} variant="outlined">
                            {touched.duplicateCheck && errors.duplicateCheck}
                          </FormHelperText>
                        </div>
                      )}
                    </>
                  )}
                  {/* {values?.recordType?.value === "Data Export" && (
                    <>
                      <div className={`col-sm-6 col-md-3 form-group`}>
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          id="changesToWrite"
                          options={changesToWrite}
                          value={values?.changesToWrite}
                          size="small"
                          autoHighlight
                          disabled={Boolean(basicInfoData?.changeToWrite)}
                          getOptionLabel={(option) => {
                            return option && option.value;
                          }}
                          onChange={(e, data) => {
                            setFieldValue("changesToWrite", data);
                          }}
                          renderInput={(params) => (
                            <GuiTextField
                              margin="dense"
                              {...params}
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              fullWidth
                              label="Changes To write"
                              required
                              error={Boolean(touched.changesToWrite && errors.changesToWrite)}
                              name="changesToWrite"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              placeholder="Select Changes To write"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "off",
                              }}
                            />
                          )}
                        />
                        <FormHelperText style={{ color: "red" }} variant="outlined">
                          {touched.changesToWrite && errors.changesToWrite}
                        </FormHelperText>
                      </div>
                      <div className={`col-sm-6 col-md-3 form-group`}>
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          id="strategy"
                          options={strategyType}
                          value={values?.strategy}
                          disabled={Boolean(basicInfoData?.fieldStrategy)}
                          size="small"
                          autoHighlight
                          getOptionLabel={(option) => {
                            return option && option.value ? option.value : "";
                          }}
                          onChange={(e, data) => {
                            setFieldValue("strategy", data);
                          }}
                          renderInput={(params) => (
                            <GuiTextField
                              margin="dense"
                              {...params}
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              variant="outlined"
                              fullWidth
                              label="Field Populate Strategy"
                              required
                              error={Boolean(touched.strategy && errors.strategy)}
                              name="strategy"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              placeholder="Select Field Populate Strategy"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "off",
                              }}
                            />
                          )}
                        />
                        <FormHelperText style={{ color: "red" }} variant="outlined">
                          {touched.strategy && errors.strategy}
                        </FormHelperText>
                      </div>
                    </>
                  )} */}
                  {values?.headerLines > 0 && (
                    <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        id="dynamic"
                        value={values?.dynamic}
                        options={fixedLengthOptions?.length > 0 ? fixedLengthOptions : []}
                        size="small"
                        autoHighlight
                        getOptionDisabled={(option) => option?.key === null}
                        getOptionLabel={(option) => {
                          return option?.value ? option?.value : '';
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            className={` ${classes.labelName} `}
                            {...params}
                            variant="outlined"
                            fullWidth
                            margin="dense"
                            label="Dynamic Column Mapping"
                            name="dynamic"
                            error={Boolean(touched.dynamic && errors.dynamic)}
                            required
                            placeholder="Select Dynamic Column Mapping"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                        onChange={(e, data) => {
                          setFieldValue('dynamic', data);
                        }}
                      />
                      <FormHelperText variant="outlined">
                        {touched.dynamic && errors.dynamic}
                      </FormHelperText>
                    </div>
                  )}
                  {exportManagerRecord && (
                    <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        name="includeAudit"
                        id="includeAudit"
                        size="small"
                        options={promptOptions}
                        required
                        value={values.includeAudit}
                        disabled={Boolean(basicInfoData?.includeAudit)}
                        getOptionLabel={(option) => {
                          return option && option.value;
                        }}
                        onChange={(e, value) => {
                          setFieldValue('includeAudit', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={` ${classes.labelName} `}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Include Audit"
                              placeholder="Select Include Audit"
                              required
                              error={touched.includeAudit && errors.includeAudit}
                            />
                          </div>
                        )}
                      />
                      <FormHelperText>
                        {touched.includeAudit && errors.includeAudit && errors.includeAudit}
                      </FormHelperText>
                    </div>
                  )}
                </div>

                <div className="d-flex justify-content-center align-items-center new-standard-textfields disabled-button">
                  <Button
                    variant="outlined"
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                    disabled={activeStep === 0}
                  >
                    Back
                  </Button>
                  {/* {isDraftRecord === "N" && ( */}
                  <Button
                    variant="outlined"
                    type="button"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    disabled={(editExisting && !dmTempRecordAccess?.edit) || enabledSubmission}
                    onClick={() => {
                      saveRef.current = true;
                      handleDirty(false, 'fixed');
                      handleSubmit(values);
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 ${classes.buttonRoot}`}
                    disabled={(editExisting && !dmTempRecordAccess?.edit) || enabledSubmission}
                    onClick={() => {
                      saveRef.current = false;
                    }}
                  >
                    Save & Next
                  </Button>
                </div>
              </form>
              <DialogBox
                open={open}
                dialogClose={handleClose}
                title="Search For Parent Import Record"
                maxWidth="xl"
              >
                <SearchRecords
                  mapRecord={true}
                  mapRecordForException={true}
                  mappedRecordForExceptionData={mappedRecordForExceptionData}
                  setMappedRecordForExceptionData={setMappedRecordForExceptionData}
                  handleClose={handleClose}
                  setParentRecord={setFieldValue}
                  setTempSelectedRows={setTempSelectedRows}
                  tempSelectedRows={tempSelectedRows}
                  mappingMasterRecordTypes={[
                    'New Account Import',
                    // "New Payment Import",
                    'Data Update',
                  ]}
                />
              </DialogBox>
            </>
          );
        }}
      </Formik>

      {(isBasicInfoLoading || printUsageIsLoading) && <PageLoader />}
      {(basicInfoErrorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={basicInfoErrorMsg || printUsageErrorMsg} />
      )}
      {(basicInfoSuccessMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={basicInfoSuccessMsg || printUsageSuccessMsg} />
      )}
    </>
  );
};
export default DMRBasicInfo;
